'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import type { APILanguage } from '@openclassrooms/sdk';
import { DataConnectProvider } from '@openclassrooms/data-connect-web/utils';
import { initSDK, Client } from '@/modules/sdk';
declare global {
  interface Window {
    sdk: Client;
  }
}
type Props = {
  children: React.ReactNode;
  language: string;
};
export const SDKProvider = t0 => {
  const $ = _c(4);
  const {
    children,
    language
  } = t0;
  let t1;
  if ($[0] !== language) {
    t1 = () => {
      initSDK({
        language: language as APILanguage
      }).then(_temp);
    };
    $[0] = language;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useState(t1);
  let t2;
  if ($[2] !== children) {
    t2 = <DataConnectProvider withoutUserContext={true}>{children}</DataConnectProvider>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(client) {
  if (globalThis.window) {
    globalThis.window.sdk = client;
  }
}